import { atom } from 'jotai';
import { ActionItem } from "@Eikochain/components/organisms/MarketingEditor/types";

export const canvasHistoryAtom = atom<ActionItem[]>([]);

export const canvasHistoryCurrentIndexAtom = atom<number>(0);
